<template>
  <div id='app'>
    <router-view v-if="isRouteAlive"></router-view>
  </div>
</template>
<script>
import Vue from 'vue';

import zh_cn from './i18n/zh_CN'

import {
  SliderPlugin,
  TextBoxPlugin,
  NumericTextBoxPlugin,
  MaskedTextBoxPlugin,
  UploaderPlugin
} from '@syncfusion/ej2-vue-inputs';
import {
  ButtonPlugin,
  CheckBoxPlugin,
  RadioButtonPlugin,
  SwitchPlugin
} from '@syncfusion/ej2-vue-buttons';
import {
  DropDownButtonPlugin
} from '@syncfusion/ej2-vue-splitbuttons';
import { DashboardLayoutPlugin } from "@syncfusion/ej2-vue-layouts";
import {
  DropDownListPlugin,
  ComboBoxPlugin,
  AutoCompletePlugin,
  MultiSelectPlugin,
  ListBoxPlugin
} from '@syncfusion/ej2-vue-dropdowns';
import {
  CalendarPlugin,
  DatePickerPlugin,
  TimePickerPlugin,
  DateTimePickerPlugin,
  DateRangePickerPlugin
} from '@syncfusion/ej2-vue-calendars';
import {
  GridPlugin,
  PagerPlugin,
  Resize
} from '@syncfusion/ej2-vue-grids';
import {
  TreeGridPlugin,
} from '@syncfusion/ej2-vue-treegrid';
import {
  MenuPlugin,
  SidebarPlugin,
  TabPlugin,
  ToolbarPlugin,
  TreeViewPlugin,
  AccordionPlugin,
  ContextMenuPlugin
} from '@syncfusion/ej2-vue-navigations';
import {
  ToastPlugin
} from '@syncfusion/ej2-vue-notifications';
import {
  DialogPlugin,
  TooltipPlugin
} from '@syncfusion/ej2-vue-popups';
import {
  L10n,
  loadCldr,
  setCulture,
  setCurrencyCode,
  enableRipple
} from '@syncfusion/ej2-base';
import { ListViewPlugin } from '@syncfusion/ej2-vue-lists';
import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
import JsonExcel from 'vue-json-excel';
import VueCodemirror from 'vue-codemirror';
import layerPlugin from './plugins/ej2LayerPlugin';
import loadding from './plugins/loadding';

import * as numberingSystems from './cldr/supplemental/numberingSystems'
import * as gregorian from './cldr/main/zh/ca-gregorian'
import * as numbers from './cldr/main/zh/numbers'
import * as timeZoneNames from './cldr/main/zh/timeZoneNames'
import * as currencies from './cldr/main/zh/currencies'
import * as weekData from './cldr/supplemental/weekData'
import { EventBus } from './plugins/eventBus'
import en_US from "./i18n/en_US";
enableRipple(true);

Vue.use(SliderPlugin);
Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(MaskedTextBoxPlugin);
Vue.use(UploaderPlugin);
Vue.use(ButtonPlugin);
Vue.use(CheckBoxPlugin);
Vue.use(ContextMenuPlugin);
Vue.use(RadioButtonPlugin);
Vue.use(DashboardLayoutPlugin);
Vue.use(SwitchPlugin);
Vue.use(DropDownButtonPlugin);
Vue.use(DropDownListPlugin);
Vue.use(ComboBoxPlugin);
Vue.use(AutoCompletePlugin);
Vue.use(MultiSelectPlugin);
Vue.use(ListBoxPlugin);
Vue.use(CalendarPlugin);
Vue.use(DatePickerPlugin);
Vue.use(TimePickerPlugin);
Vue.use(DateTimePickerPlugin);
Vue.use(DateRangePickerPlugin);
Vue.use(GridPlugin);
Vue.use(PagerPlugin);
Vue.use(MenuPlugin);
Vue.use(SidebarPlugin);
Vue.use(TabPlugin);
Vue.use(ToolbarPlugin);
Vue.use(TreeViewPlugin);
Vue.use(AccordionPlugin);
Vue.use(ToastPlugin);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(TreeGridPlugin);
Vue.use(VueCodemirror);
Vue.use(ListViewPlugin);
Vue.use(layerPlugin);
Vue.use(loadding);
Vue.use(JsonExcel);

export default {
  name: 'App',
  provide() {
    reload: this.reload
  },
  data() {
    return {
      isRouteAlive: false
    }
  },
  mounted() {
    createSpinner({
      target: document.getElementById('app')
    });
    EventBus.$on('loading', ({ison}) => {
      if (ison) {
        this.showloading();
      } else {
        this.hideLoading();
      }
    })
    this.init();
  },
  methods: {
    init() {
      this.$axios.get('/lte/security/findSystemLanguage', {}).then(res => {
        let language = res.data;
        let locale = 'zh';
        if(language == 'zh_CN') {
          locale = 'zh';
          loadCldr(numberingSystems, gregorian.default, numbers.default, timeZoneNames.default, currencies.default, weekData);
          setCulture('zh');
          setCurrencyCode('CNY');
          L10n.load({
            'zh': zh_cn.ej2Components
          });
        }else {
          locale = 'en';
          setCulture('en');
          /*L10n.load({
            'en': en_US.ej2Components
          });*/
        }
        localStorage.setItem('locale', locale);
        // 中文 LOCALE === zh 英文 LOCALE === en
        Vue.prototype.LOCALE = localStorage.getItem('locale') ? localStorage.getItem('locale') : 'zh';
        this.$i18n.locale = locale;
        this.reload()
      })
    },
    reload() {
      this.isRouteAlive = false;
      this.$nextTick(function() {
        this.isRouteAlive = true;
      })
    },
    showloading() {
      showSpinner(document.getElementById('app'));
      // setTimeout(this.hideLoading, 1000)
    },
    hideLoading() {
      hideSpinner(document.getElementById('app'))
    }
  }
};
</script>
<style>
@import "./styles/bootstrap.min.css";
@import "./assets/iconfont/iconfont.css";
@import '../node_modules/@syncfusion/ej2-base/styles/bootstrap4.css';
@import '../node_modules/@syncfusion/ej2-vue-layouts/styles/bootstrap4.css';
@import "../node_modules/@syncfusion/ej2-vue-buttons/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-splitbuttons/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-inputs/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-dropdowns/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-calendars/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-grids/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-treegrid/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-navigations/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-notifications/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-popups/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-popups/styles/bootstrap4.css";
@import "../node_modules/@syncfusion/ej2-vue-lists/styles/bootstrap4.css";
@import "../node_modules/codemirror/lib/codemirror.css";

body {
  margin: 0;
  padding: 0;
}
.e-dialog .e-footer-content button.e-btn.e-flat.primary-btn{
  background-color: #1890ff;
  border-color: #1890ff;
  color: #ffffff;
}
@font-face {
  font-family: 'toast-icons';
  src: url(data:application/x-font-ttf;charset=utf-8;base64,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) format('truetype');
  font-weight: normal;
  font-style: normal;
}
.e-toast-container .e-toast .e-toast-icon {
  position: relative;
  top: 10px;
  left: 0;
  font-size: 30px;
}

.toast-icons {
  font-family: 'toast-icons' !important;
}

.toast-icons.e-success::before {
  content: "\e701";
}

.toast-icons.e-error::before {
  content: "\e700";
}

.toast-icons.e-info::before {
  content: "\e704";
}

.toast-icons.e-warning::before {
  content: "\e703";
}
.e-spinner-pane {
  z-index: 1300;
}
.e-upload .e-file-drop {
  display: none;
}
</style>
